// extracted by mini-css-extract-plugin
export default {"deleteModal":"styles_deleteModal__o9Lga","deleteIcon":"styles_deleteIcon__6dUeo","svg":"styles_svg__WNoNk"};